import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardElementController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardElementController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
const UpdateTemplateDashboardElementController = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTemplateDashboardElementController.url(args, options),
    method: 'put',
})

UpdateTemplateDashboardElementController.definition = {
    methods: ["put"],
    url: '/api/template-dashboard/{template_dashboard}/{element}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardElementController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardElementController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
UpdateTemplateDashboardElementController.url = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
            element: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
        element: args.element,
    }

    return UpdateTemplateDashboardElementController.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace('{element}', parsedArgs.element.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardElementController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardElementController.php
* @route '/api/template-dashboard/{template_dashboard}/{element}'
*/
UpdateTemplateDashboardElementController.put = (args: { template_dashboard: string | number | { id: string | number }, element: string | number } | [template_dashboard: string | number | { id: string | number }, element: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTemplateDashboardElementController.url(args, options),
    method: 'put',
})

export default UpdateTemplateDashboardElementController